import React, { useCallback, useState } from "react";
import CommonModal from "../../../../../components/modal/CommonModal";
import InputText from "../../../../../components/inputs/InputText";

function AddPurchasePaymentModal({ closeModal, amount, addPayment }: any) {
  const [formData, setformData] = useState({
    total: amount.total,
    netTotal: amount.total,
    discount: 0,
    card: 0,
    cash: 0,
    errors: false,
    due: amount.total,
  });
  const handleChange = useCallback((e: any) => {
    const { name, value } = e.target;

    if (name == "discount") {
      setformData((prevData) => ({
        ...prevData,
        [name]: value,
        netTotal: amount.total - value,
      }));
    } else if (name == "card") {
      setformData((prevData) => ({
        ...prevData,
        [name]: value,
        due: prevData.netTotal - prevData.cash - value,
      }));
    } else if (name == "cash") {
      setformData((prevData) => ({
        ...prevData,
        [name]: value,
        due: prevData.netTotal - prevData.card - value,
      }));
    } else {
      setformData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  }, []);
  const handleSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (
        formData.total *
          formData.netTotal *
          (formData.card || formData.cash) >
        0
      ) {
        addPayment(formData);
      } else {
        setformData((prevData) => {
          return {
            ...prevData,
            errors: true,
          };
        });
      }
    },
    [addPayment, formData]
  );
  return (
    <CommonModal closeModal={closeModal} title={"Add Payment"}>
      <form onSubmit={handleSubmit}>
        <InputText
          name="total"
          label="Total"
          value={formData.total}
          onChange={handleChange}
          errors={formData.errors && formData.total <= 0}
          isDisable={true}
        />
        <InputText
          name="discount"
          label="Discount"
          value={formData.discount}
          onChange={handleChange}
          errors={formData.errors && formData.netTotal <= 0}
        />
        <InputText
          name="netTotal"
          label="Net Total"
          value={formData.netTotal}
          onChange={handleChange}
          isDisable={true}
        />
        <InputText
          name="card"
          label="Card"
          value={formData.card}
          onChange={handleChange}
          errors={formData.errors && formData.card <= 0}
        />
        <InputText
          name="cash"
          label="Cash"
          value={formData.cash}
          onChange={handleChange}
          errors={formData.errors && formData.cash <= 0}
        />
        <InputText
          name="due"
          label="Due"
          value={formData.due}
          onChange={handleChange}
          errors={formData.errors && formData.due <= 0}
          isDisable={true}
        />
        <button type="submit">submit</button>
      </form>
    </CommonModal>
  );
}

export default AddPurchasePaymentModal;
